module.exports = function() {
  return new Worker(__webpack_public_path__ + "c1df18e37ffc9a891f2d.worker.js");
};